let g_API_BASE_URL = "";
let g_UI_BASE_URL = "";

if (process.env.NODE_ENV === "development") {
  let devHost = process.env.VUE_APP_DEV_HOST;
  if (process.env.MODE_TYPE === "1") {
    devHost = process.env.VUE_APP_t_DEV_HOST;
  }
  g_API_BASE_URL = process.env.VUE_APP_g_UI_BASE_URL;
  g_UI_BASE_URL = "http://" + devHost + ":3000";
} else {
  g_API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
  g_UI_BASE_URL = process.env.VUE_APP_BASE_URL;
}

// export const API_BASE_URL = g_API_BASE_URL;
export const API_BASE_URL = g_API_BASE_URL;

export const UI_BASE_URL = g_API_BASE_URL;

let sUserAgent = window.navigator.userAgent.toLowerCase();
let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
let bIsMidp = sUserAgent.match(/midp/i) == "midp";
let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
let bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
let bIsAndroid = sUserAgent.match(/android/i) == "android";
let bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
let bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
let bIsTablet = sUserAgent.match(/tablet/i) == "tablet";
let bIsGoolgeBotMobile =
  sUserAgent.match(/Goolgebot/i) == "Goolgebot" &&
  (sUserAgent.match(/Mobile/i) ||
    "Mobile" ||
    sUserAgent.match(/Android/i) == "Android" ||
    sUserAgent.match(/AppleWebKit/i)) == "AppleWebKit";
let bIsMiui = /miuibrowser|xiaomi\/miuibrowser/.test(sUserAgent);
let bIsQQ = /qqbrowser|mqqbrowser/.test(sUserAgent);
let bIsVivo = /vivo/.test(sUserAgent);
let bIsMac = /mac/i.test(sUserAgent); 
let bIsKL = /line|kakao/.test(sUserAgent);
let bIsOppo = /heytapbrowser|oppo/.test(sUserAgent);
let bIsSamSung = /samsung/.test(sUserAgent);

// 检测是否有触控点和touch事件 -> 触控设备
const maxTouchPoints = window.navigator.maxTouchPoints ?? 0;
const bIsTouchDevice = maxTouchPoints > 1;
const bIsHasTEvt = 'ontouchstart' in window || 'ontouchend' in window || 'ontouchmove' in window;

let device = {};
if (bIsIphoneOs) device.isApple = true;
let isMobile =
  (bIsIphoneOs ||
    bIsMidp ||
    bIsUc7 ||
    bIsUc ||
    bIsAndroid ||
    bIsCE ||
    bIsWM ||
    bIsGoolgeBotMobile);
let isTouchDevice = bIsIpad || bIsTablet || bIsTouchDevice || bIsHasTEvt;
// 单独手机移动设备，识别
if (isMobile) {
  device.isPureMobile = true;
}
// 非手机的触控设备
if (!isMobile && isTouchDevice) {
  device.isPad = true;
  // 需要识别ipad
  if (bIsMac || bIsIpad) {
    device.isIpad = true;
  }
}
// 触控设备统一识别为 isMobile
if (isMobile || isTouchDevice) {
  device.isMobile = true;
}
if (!isMobile && !isTouchDevice) {
  device.isPC = true;
}
if (bIsMiui || bIsQQ) {
  device.isMIorQQ = true;
}
if (bIsVivo) {
  device.isVivo = true;
}
if (bIsMac) {
  device.isMac = true;
}
if (bIsKL) {
  device.isKL = true;
}
if (bIsOppo || bIsMiui || bIsVivo) {
  device.isOMV = true;
}
if (bIsSamSung) {
  device.isSamSung = true;
}

export const DEVICE_TYPE = device;

// 返回client_type
let client_type = "";
if (DEVICE_TYPE.isApple) {
  client_type = "ios";
}
if (bIsAndroid) {
  client_type = "android";
}
if (DEVICE_TYPE.isPC && !DEVICE_TYPE.isMac) {
  client_type = "windows";
}
if (DEVICE_TYPE.isPC && DEVICE_TYPE.isMac) {
  client_type = "mac";
}

export const CLIENT_TYPE = client_type;

// 区分正式服测试服预发布域名以及对应的cos

let serverEnv = "";
switch (window.location.host) {
  case "cloudgame-br.qcloud.com":
    serverEnv = "https://cdn.cloudgame-br.qcloud.com";
    break;
  case "xgame.qcloud.com":
    serverEnv =
      "https://ct-global-dev-cd-1300343054.cos.ap-chengdu.myqcloud.com";
    break;
  case "cloudgame-test.gameexp.com":
    serverEnv =
      "https://cdn.cloudgame.qcloud.com";
    break;
  case "cloudgame.qcloud.com":
    serverEnv = "https://cdn.cloudgame.qcloud.com";
    break;
  default:
    serverEnv =
    "https://cdn.cloudgame.qcloud.com";
    break;
}

export const COSADDR = serverEnv;
const time = "11251907";
export function CheckImgExistsH5(name, gameId, url) {
  return new Promise(function (resolve, reject) {
    // if (isCustomH5) {
    const ImgObj2 = new Image();
    const url = `${COSADDR}/game/assets-h5/${gameId}-H5/${name}.png?time=${time}`;
    ImgObj2.src = url;
    // console.log(url);
    ImgObj2.onload = function () {
      resolve(`url(${url})`);
    };
    ImgObj2.onerror = function () {
      // isCustomH5 = false;
      const ImgObj = new Image();
      ImgObj.src = `${COSADDR}/game/assets-default/${name}.png?time=${time}`;
      ImgObj.onload = function () {
        resolve(getDefaultCosAddress(name, gameId));
      };
      ImgObj.onerror = function () {
        reject("");
      };
    };
    // } else {
    //   const ImgObjDefault = new Image();
    //   ImgObjDefault.src = COSADDR + "/game/assets-default/" + name + ".png";
    //   ImgObjDefault.onload = function () {
    //     resolve(getDefaultCosAddress(name, gameId));
    //   };
    // }
  });
}

// 获取自定义icon cos地址 H5
export function getCosH5Address(name, gameId) {
  // return ImageIsExist(name, gameId, getSrcCosAddressH5(name, gameId));
  return CheckImgExistsH5(name, gameId, getSrcCosAddressH5(name, gameId));
}

// 获取自定义icon cos地址 H5
export function getSrcCosAddressH5(name, gameId) {
  return `${COSADDR}/game/assets-h5/${gameId}-H5/${name}.png?time=${time}`;
}

// 获取默认icon cos地址
export function getDefaultCosAddress(name, gameId) {
  return "url('" + COSADDR + "/game/assets-default/" + name + ".png')";
}

export const GameThemeColor = {
  "default": "#7e7bfc",
  "8bd999": "#7e7bfc",
  545007: "#8296b3",
  "2l56r5": "#8296b3",
  bbg7bb: "rgb(34,122,181)",
  "60989g": "#bc6b1d",
  "0gb7a5": "#64d0fb",
  "7pq4k4": "#64d0fb",
  "474ga5": "#a2f9f0",
  "796m43": "#a2f9f0",
};

export const GameBackgroundColor = {
  "default": "#464450",
  "8bd999": "#464450",
  "545007": "#404a5f",
  "2l56r5": "#404a5f",
  "bbg7bb": "#464450",
  "0gb7a5": "#464450",
  "7pq4k4": "#464450",
};

export const GameMenuBackgroundColor = {
  "default": "#464450",
  "0gb7a5": "rgba(0,0,0,0.5)",
  "7pq4k4": "rgba(0,0,0,0.5)",
};

export const GameConfirmColor = {
  "8bd999": "#523fff",
  545007: "#62c1b6",
  "2l56r5": "#62c1b6",
  bbg7bb: "#523fff",
};

// 默认背景时
export const GameTextColor = {
  "60989g": "#5f5952",
};

// 特殊浅色背景时
export const GameTextColor2 = {
  "0gb7a5": "#000000",
  "7pq4k4": "#000000",
};

export function notEmpty(value) {
  return (
    value !== "undefined" &&
    value !== undefined &&
    value !== null &&
    value !== ""
  );
}

let isProd = false;
let host = window.location.hostname;
if (host == 'cloudgame-br.qcloud.com') {
  isProd = true;
}
export const isProdEnv = isProd;

let imgDomain = 'https://cdn.cloudgame.qcloud.com';
export const ImgDomain = imgDomain;

// 获取自定义icon cos地址
export function getCosAddress(name, gameId) {
  // return ImageIsExist(name, gameId, getSrcCosAddressPC(name, gameId));
  return CheckImgExistsPC(name, gameId, getSrcCosAddressH5(name, gameId));
  // ? "url('" + COSADDR + "/game/assets-pc/" + gameId + "-PC/" + name + ".png" + "')"
  // : getDefaultCosAddress(name, gameId);
  // return "url(" + COSADDR + "/game/assets-pc/" + gameId + "-PC/" + name + ".png" + ")";
}

// 获取默认icon cos地址 H5
export function getDefaultCosAddressH5(name, gameId) {
  return `${COSADDR}/game/assets-default/${name}.png?time=${time}`;
}

export function CheckImgExistsPC(name, gameId, url) {
  return new Promise(function (resolve, reject) {
    const ImgObj2 = new Image();
    const url = `${COSADDR}/game/assets-pc/${gameId}-PC/${name}.png?time=${time}`;
    ImgObj2.src = url;
    ImgObj2.onload = function () {
      resolve(`url(${url})`);
    };
    ImgObj2.onerror = function () {
      const ImgObj = new Image();
      ImgObj.src = `${COSADDR}/game/assets-default/${name}.png?time=${time}`;
      ImgObj.onload = function () {
        resolve(getDefaultCosAddress(name, gameId));
      };
    };
  });
}

export function getUrlParameter(search, name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');

  let results = regex.exec(search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

let lang = "en";
const userLang = navigator.language.toLowerCase();
if (userLang.indexOf('ko') > -1) {
  lang = "ko";
}
if (userLang.indexOf('th') > -1) {
  lang = "th";
}
if (userLang.indexOf('ms') > -1) {
  lang = "my"
}
if (userLang.indexOf('id') > -1) {
  lang = "id"
}
export const LANG = lang;

export function preloadImages(names, gameId) {
  names.forEach((name) => {
    const img = new Image(); 
    img.src = `${COSADDR}/game/assets-h5/${gameId}-H5/${name}.png?time=${time}`;
  });
}

// 预加载下载图片
export function preloadDowloadImages(gameId) {
  const urls = [
    `download-box-${LANG}-0`,
    `download-box-${LANG}-1`,
    `download-box-${LANG}-2`,
    `download-box-${LANG}-3`,
    `download-box-${LANG}-4`,
  ]
  preloadImages(urls, gameId);
}

export function getBannerGif(name, gameId) {
  return new Promise(function (resolve) {
    const ImgObj2 = new Image();
    const url = `${COSADDR}/game/assets-h5/${gameId}-H5/${name}.gif?time=${time}`;
    ImgObj2.src = url;
    console.log(url);
    ImgObj2.onload = function () {
      resolve(url);
    };
  });
}

export function isHOK() {
  const gameId = window.location.pathname.split("/").pop();
  if (["76b477", "bbg7bb", "g4b7bb"].includes(gameId)) {
    return true;
  }
  return false;
}

export function isUAMO() {
  const gameId = window.location.pathname.split("/").pop();
  if (gameId == "8bd0a6") {
    return true;
  }
  return false;
}

export function isNikke() {
  const gameId = window.location.pathname.split("/").pop();
  if (["7pq4k4", "0gb7a5"].includes(gameId)) {
    return true;
  }
  return false;
}

export function isPubgm() {
  const gameId = window.location.pathname.split("/").pop();
  if (["474ga5", "796m43", "780loq"].includes(gameId)) {
    return true;
  }
  return false;
}

export function needDebug() {
  const gameId = window.location.pathname.split("/").pop();
  return ["474ga5", "780loq"].includes(gameId);
}

export function getiOSVersion() {
  const userAgent = window.navigator.userAgent;
  let version = null;
  const regex = /OS (\d+_\d+(_\d+)?) like Mac OS X/i;
  const matches = userAgent.match(regex);
  if (matches) {
    version = matches[1].replace(/_/g, '.');
  }
  return parseFloat(version);
}

export function isPWA() {
  return getUrlParameter(window.location.search, "channel") == "pwa";
}

export function getUaInfoString() {
  let s;
  const ua = window.navigator.userAgent.toLowerCase();
  let kernel = (s = ua.match(/trident/)) ? 'trident' :
                (s = ua.match(/presto/)) ? 'presto' :
                (s = ua.match(/applewebkit/)) ? 'webkit' :
                (s = ua.match(/gecko/)) ? 'gecko' : undefined;
  let brand = (s = ua.match(/msie/)) ? 'ie' :
              (s = ua.match(/firefox/)) ? 'firefox' :
              (s = ua.match(/qbrowser/)) ? 'qq' :
              (s = ua.match(/ubrowser/)) ? 'uc' :
              (s = ua.match(/metasr/)) ? 'sogou' :
              (s = ua.match(/360se|360ee/)) ? '360' :
              (s = ua.match(/lbbrowser/)) ? 'liebao' :
              (s = ua.match(/maxthon/)) ? 'aoyou' :
              (s = ua.match(/quark/)) ? 'quark' :
              (s = ua.match(/opera/)) ? 'opera' :
              (s = ua.match(/chrome/)) ? 'chrome' :
              (s = ua.match(/safari/)) ? 'safari' : undefined;
  if (!kernel || !brand) {
    return `undefined_${ua.slice(0, 20)}`;
  }
  return `${kernel}_${brand}`;
}

console.log("uastring", getUaInfoString());

// 预加载弹窗图片
export function preloadDialogImages(gameId) {
  const urls = [
    `modal-content`,
    `cancel-btn`,
    `confirm-btn`,
  ]
  preloadImages(urls, gameId);
}
